import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import DashboardLayout from '../common/DashboardLayout';
import StateAdminServices from '../../services/StateAdminServices';
import './StatePages.css';

const STATE_NAMES = {
  'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California',
  'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'FL': 'Florida', 'GA': 'Georgia',
  'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa',
  'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
  'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri',
  'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey',
  'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio',
  'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
  'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont',
  'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming',
  'DC': 'District of Columbia'
};

const Reports = () => {
  const { userrole } = useContext(AuthContext);
  const { type = '' } = useParams();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const stateId = localStorage.getItem('stateid') || user.stateid || 'IN';
  const stateName = STATE_NAMES[stateId] || stateId;

  const [reports, setReports] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    loadReports();
  }, [startDate, endDate]);

  const loadReports = async () => {
    setIsLoading(true);
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (type === 'certifications') params.reportType = 'certifications';

      const response = await StateAdminServices.getStateReports(params);
      if (response.success && response.data) {
        setReports(response.data);
      }
    } catch (error) {
      console.error('Error loading reports:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  if (isLoading) {
    return (
      <DashboardLayout role={4} layoutType="topnav">
        <div className="state-page">
          <div className="loading-spinner">Loading {stateName} reports...</div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout role={4} layoutType="topnav">
      <div className="state-page">
        <div className="page-header">
          <h1>{stateName} Reports</h1>
        </div>

        {(type === 'date-range' || type === 'custom') && (
          <div className="filters-section">
            <div className="filter-controls">
              <div className="filter-group">
                <label>Start Date:</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="filter-select"
                />
              </div>
              <div className="filter-group">
                <label>End Date:</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="filter-select"
                />
              </div>
            </div>
          </div>
        )}

        {type === 'certifications' && reports && (
          <div>
            <h2>Certifications Overview</h2>
            <p>Total Certifications: {reports.totalCertifications}</p>
            <table className="reports-table">
              <thead>
                <tr>
                  <th>Teacher Name</th>
                  <th>Teacher Email</th>
                  <th>School Name</th>
                  <th>Course</th>
                  <th>Date Completed</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {reports.certifications?.map((cert) => (
                  <tr key={cert.id}>
                    <td>{cert.teacherName}</td>
                    <td>{cert.teacherEmail}</td>
                    <td>{cert.schoolName}</td>
                    <td>{cert.courseTitle || cert.courseKey}</td>
                    <td>{formatDate(cert.dateCompleted)}</td>
                    <td>
                      <span className={`status-badge status-${cert.status === 'completed' ? 'compliant' : 'at-risk'}`}>
                        {cert.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {type === 'custom' && (
          <div className="analytics-card">
            <h3>Custom Reports</h3>
            <p>Custom report builder coming soon. This will allow you to create custom reports with specific filters and fields.</p>
          </div>
        )}

        {!type && (
          <div className="analytics-card">
            <h3>Reports</h3>
            <p>Select a report type from the menu to view detailed reports.</p>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Reports;

